/**
 * Shared types for Vehicle Logbook application
 */
export const FREE_TIER_LIMITS = {
    maxVehicles: 2,
    maxRecordsPerVehicle: 50,
    maxStorageMB: 10,
};
// ============================================================================
// Validation Schemas
// ============================================================================
export const SUPPORTED_FILE_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/webp',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const CURRENCIES = ['UAH', 'USD', 'EUR', 'GBP'];
